import settings from '../assets/settings.json';
import auth_obj from '../assets/auth.json';
import Cookies from 'js-cookie'

class FunctionFields {

  loginVaridation(input_datas, app_obj){
    let result = true;
    let i = 0;

    for (const elem of input_datas) {
      if(i===1){
        let phone = elem.value;
        Cookies.set('_replace_phone', phone, { expires: 1/2 }) //半日
      }

      if(i===2){
        if(elem.value!==app_obj.store[0]){
            result = false;
        }
      }else if(i===3){
        if(elem.value!==app_obj.store[1]){
            result = false;
        }
      }else if(i===4){
        let input_name = elem.value;
        Cookies.set('_replace_staff', input_name, { expires: 365 })
        //console.log(input_name);
        //console.log(auth_obj.staff);
        let isit_name = auth_obj.staff.includes(input_name)
        if (isit_name) {
            //console.log("OK_NAME");
        }else{
            result = false;
        }
      }
      
      i++;
    }

    return result;
  }




  getMyToken(staff_name, phone, auth_obj){
    phone = phone.replace(/-/g, '');
    staff_name = encodeURIComponent(staff_name);
    const url = settings.API_BASE_URL + settings.API_CHECK_STAFF + '?token=' + auth_obj.token + '&name='+ staff_name + '&phone='+phone;
    //const url = 'https://api.hello-remix.com/?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0aW0iLCJleHAiOjE2Nzg2OTQwOTd9.09g9boZ9CGt8UGOtRhnfGAp-jkQY4t0bJptvRKRsq3M';
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    //console.dir(JSON.parse(Httpreq.responseText));
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj.result); // registerd
    console.dir(response_obj.token);

    return response_obj.token;
  }

  
}

const addFunction = new FunctionFields();

export { addFunction };